// blend-loader.js
// ✅ This module will hydrate blend data from Azure Blob Storage via `?id=` URL param
// and inject it into the existing UI logic on custom-blend.liquid page.
 
// ──────────────────────────────────────────────────────────────
// Black Friday 2025 Promo: Free 3oz Signature Mini
// ──────────────────────────────────────────────────────────────
const BF_PROMO_CONFIG = window.__BF_PROMO_CONFIG || {};

// Customer portal base — set per environment via window.CANDLECRAFT_PORTAL_BASE
// (wired in theme.liquid from snippets/candlecraft-env.liquid). Falls back to prod.
const PORTAL_BASE = String(window.CANDLECRAFT_PORTAL_BASE || 'https://myscents.candlecraftcollective.com').replace(/\/+$/, '');

const BF_PROMO_ENABLED = BF_PROMO_CONFIG.enabled !== undefined ? !!BF_PROMO_CONFIG.enabled : true; // toggle to false after the event
function parsePromoDate(value, fallback) {
  if (!value) return fallback;
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? fallback : parsed;
}

const BF_PROMO_START = parsePromoDate(BF_PROMO_CONFIG.start, new Date('2025-11-15T00:00:00-06:00')); // CST timezone
const BF_PROMO_END   = parsePromoDate(BF_PROMO_CONFIG.end, new Date('2025-12-01T00:00:00-06:00')); // exclusive end

// 3oz mini variant IDs (DO NOT CHANGE - these match Shopify products)
const MINI_VARIANT_IDS = {
  hearth: 43588505174118,
  soiree: 43588453793894,
  haven: 43588400087142,
  muse: 43588270096486
};

/**
 * Check if current date is within Black Friday promo window
 * @param {Date} now - Current date (defaults to now)
 * @returns {boolean}
 */
function isBlackFridayWeekend(now = new Date()) {
  if (!BF_PROMO_ENABLED) return false;
  return now >= BF_PROMO_START && now < BF_PROMO_END;
}

/**
 * Get 3oz mini variant ID for a recommended signature scent
 * @param {string} recommendedName - Signature scent name (e.g., "Muse", "Haven", "Hearth", "Soirée")
 * @returns {number|null} - Variant ID or null if not found
 */
function getMiniVariantId(recommendedName) {
  if (!recommendedName) return null;
  const key = recommendedName.trim().toLowerCase()
    .replace(/é/g, 'e')  // normalize Soirée -> soiree
    .replace(/[^a-z]/g, ''); // remove any other special chars
  return MINI_VARIANT_IDS[key] || null;
}

/**
 * Extract recommended signature scent name from blend data
 * @param {Object} blendData - The blend data object
 * @returns {string|null} - Signature scent name (Muse, Haven, Hearth, Soirée) or null
 */
function getRecommendedSignatureName(blendData) {
  if (!blendData) return null;
  
  // Check scentMapSnapshot first (most reliable)
  const scentMap = blendData.scentMapSnapshot || {};
  const topTwo = blendData.topTwo || [];
  
  if (topTwo.length > 0 && topTwo[0].cat) {
    const topCategory = topTwo[0].cat;
    const recommendation = scentMap[topCategory];
    if (recommendation && recommendation.product) {
      return recommendation.product; // e.g., "Muse", "Haven", etc.
    }
  }
  
  // Fallback: try to get from stored blend data
  try {
    const lastBlendId = localStorage.getItem('lastBlendId');
    if (lastBlendId) {
      const raw = sessionStorage.getItem('blendSession.' + lastBlendId);
      if (raw) {
        const stored = JSON.parse(raw);
        return getRecommendedSignatureName(stored); // recursive check
      }
    }
  } catch (e) {
    console.warn('Could not retrieve recommended signature from storage:', e);
  }
  
  return null;
}

// Make functions globally available for cart add logic
window.isBlackFridayWeekend = isBlackFridayWeekend;
window.getMiniVariantId = getMiniVariantId;
window.getRecommendedSignatureName = getRecommendedSignatureName;

// ---- Minimal schema check (JS) for the blobs that exist: v2 (blend engine) and v1 (browser-saved) ----
function validateBlend(b) {
  try {
    if (!b) return { ok: false, reason: 'missing' };
    if (!b.blendId || !b.blendName) return { ok: false, reason: 'ids' };
    var story = typeof b.story === 'string' ? b.story : (b.story && b.story.text) || b.aiStory;
    if (!story || !String(story).trim()) return { ok: false, reason: 'no_story' };

    // v2: engine recipe in whole grams with a total; v1: the AI recipe list.
    var hasEngineRecipe = b.recipe && Array.isArray(b.recipe.components);
    var components = hasEngineRecipe ? b.recipe.components : b.aiRecipe;
    if (!Array.isArray(components) || !components.length) return { ok: false, reason: 'no_recipe' };
    if (components.some(function (c) { return !c || !c.oil || !(Number(c.grams) > 0); })) {
      return { ok: false, reason: 'bad_recipe' };
    }
    if (hasEngineRecipe) {
      var total = components.reduce(function (s, c) { return s + Number(c.grams); }, 0);
      if (!b.recipe.totalGrams || Math.abs(total - Number(b.recipe.totalGrams)) > 0.6) {
        return { ok: false, reason: 'bad_recipe_totals' };
      }
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: 'exception' };
  }
}

// ---- Report a blend that fails the check; it still renders (the page has fallbacks) ----
function reportInvalidBlend(blend) {
  var verdict = validateBlend(blend);
  if (!verdict.ok && window.logErrorToAzure) {
    window.logErrorToAzure({
      message: 'Blend failed validation',
      functionName: 'blend-loader',
      severity: 'warning',
      payload: { blendId: blend && blend.blendId, reason: verdict.reason }
    });
  }
  return verdict;
}



//create a global iconMap variable to hold the icon mappings
const iconMap = (() => {
  try {
    const raw = document.getElementById("icon-map")?.textContent;
    return JSON.parse(raw) || {};
  } catch (err) {
    console.warn("⚠️ Could not parse icon map:", err);
    return {};
  }
})();
window.iconMap = iconMap;

function pickString() {
  for (var i = 0; i < arguments.length; i++) {
    var v = arguments[i];
    if (typeof v === 'string' && v.trim()) return v.trim();
  }
  return '';
}

function normalizeWhitespace(text) {
  return String(text || '').replace(/\s+/g, ' ').trim();
}

function makeExcerpt(text, maxLen) {
  var clean = normalizeWhitespace(text);
  if (!clean) return '';
  var limit = Number.isFinite(maxLen) ? maxLen : 170;
  if (clean.length <= limit) return clean;
  var trimmed = clean.slice(0, limit);
  var lastSpace = trimmed.lastIndexOf(' ');
  if (lastSpace > 90) trimmed = trimmed.slice(0, lastSpace);
  return trimmed.replace(/[.,;:!?]$/, '') + '...';
}

function getBlendHeaderName(data) {
  return pickString(
    data?.blendName,
    data?.name,
    data?.blend_name,
    data?.blendTitle,
    data?.story?.title,
    data?.suggested_blend_name
  ) || 'Your Custom Blend';
}

function getStoryTextForExcerpt(data) {
  return pickString(
    data?.story?.summary,
    data?.story?.summaryText,
    data?.story?.excerpt,
    data?.story?.short,
    data?.summary,
    data?.storySummary,
    data?.shortStory,
    data?.story?.text,
    typeof data?.story === 'string' ? data.story : '',
    data?.aiStory,
    data?.['Scent Story']
  );
}

window.renderBlendResult = function renderBlendResult(data) {
  if (!data) return;

  // Persist for nav recovery
  if (data.blendId) {
    try {
      sessionStorage.setItem('blendSession.' + data.blendId, JSON.stringify(data));
      localStorage.setItem('lastBlendId', data.blendId);
    } catch (e) { console.warn('Could not persist blend data:', e); }
  }

  const nameEl   = document.getElementById("blend-name-preview");
  const storyEl  = document.getElementById("blend-story");
  const resultEl = document.getElementById("blend-result");
  const recEl    = document.getElementById("curated-recommendation");
  const noteEl   = document.getElementById("blend-fulfillment-note");
  const loaderEl = document.getElementById("blend-loading");

  // Normalize story (supports v1 string or v2 {text})
  const storyText =
    (typeof data.story === 'string' ? data.story : (data.story && data.story.text)) ||
    data.aiStory || ""; // legacy fallback

  const blendId     = data.blendId || null;
  const displayName = data.blendName || "Untitled Blend";
  const topTwo      = data.topTwo || [];
  const scentMap    = data.scentMapSnapshot || {};
  const signature   = topTwo[0]?.cat && scentMap[topTwo[0].cat];

  const iconPath = (cat) => {
    if (!cat) return '';
    const key = cat.toLowerCase().split(" ")[0];
    return (window.iconMap && window.iconMap[key])
      ? window.iconMap[key]
      : `/icons/${cat.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-')}.svg`;
  };

  // Always set the name
  if (nameEl) {
    nameEl.textContent = `“${displayName}”`;
    nameEl.style.display = "block";
  }

  if (storyEl) {
    storyEl.innerHTML = `<div class="blend-ai-story">${(storyText || "").replace(/\n/g, '<br>')}</div>`;
  }

  if (resultEl && topTwo.length === 2) {
    const isOnCustomBlendPage = window.location.pathname.includes('/custom-blend');
    resultEl.innerHTML = `
      <div class="scent-icon-formula blend-result-fullwidth">
        <div class="scent-icon-card"><img src="${iconPath(topTwo[0].cat)}" alt="${topTwo[0].cat}" class="scent-icon-only" /></div>
        <div class="scent-icon-plus">+</div>
        <div class="scent-icon-card"><img src="${iconPath(topTwo[1].cat)}" alt="${topTwo[1].cat}" class="scent-icon-only" /></div>
      </div>
      ${blendId && !isOnCustomBlendPage ? `
        <div class="mt-6">
          <a href="/products/custom-blend?id=${blendId}" class="button">View & Share Your Blend</a>
        </div>
      ` : ''}
    `;
    if (window.innerWidth >= 1024) {
      if (resultEl.parentElement) {
        resultEl.parentElement.style.maxWidth = 'none';
        resultEl.parentElement.style.marginLeft = '0';
        resultEl.parentElement.style.marginRight = '0';
        resultEl.parentElement.style.paddingLeft = '0';
        resultEl.parentElement.style.paddingRight = '0';
        resultEl.parentElement.style.width = '100%';
      }
      resultEl.style.width = '100%';
      resultEl.style.maxWidth = 'none';
      resultEl.style.marginLeft = '0';
      resultEl.style.marginRight = '0';
      resultEl.style.paddingLeft = '0';
      resultEl.style.paddingRight = '0';
    }
  }

  if (noteEl) noteEl.style.display = "block";

  if (signature && recEl) {
    recEl.innerHTML = `
      <h3 class="text-center text-uppercase tracking-wide text-sm text-muted mb-2">Prefer a Curated Blend?</h3>
      <p class="text-center text-lg leading-relaxed text-default max-w-md mx-auto">
        <strong>You'd love <a href="${signature.url || '#'}" class="underline">${signature.product || ''}</a>.</strong> ${signature.reason || ''}
      </p>
    `;
    recEl.style.display = "block";
  }

  loaderEl?.style.setProperty("display", "none");
  updateBlendHeader(BLEND_STATE.VALID, { blendData: data });
  if (window.location.pathname.includes('/custom-blend')) mountBlendNameField(displayName);
};

const BLEND_STATE = {
  NO_ID: 'no_id',
  INVALID: 'invalid',
  VALID: 'valid'
};

// The blend this page has validated (set by setBlendState). The purchase lock and the cart-add
// guard in custom-blend-pdp.liquid both read it through window.ccCustomBlend.
let currentBlend = { state: null, blendId: null };

function customBlendVariantIds() {
  const cfg = window.CUSTOM_BLEND || {};
  const ids = (cfg.variants || []).map((v) => String(v.id));
  if (cfg.variantId) ids.push(String(cfg.variantId));
  return new Set(ids);
}

window.ccCustomBlend = {
  // Is this variant id the custom candle (not a coaster or trimmer added from the same page)?
  isVariant: (id) => id != null && customBlendVariantIds().has(String(id)),
  // The blend id to attach to an order, or null when there's no validated blend on the page.
  validBlendId: () => (currentBlend.state === BLEND_STATE.VALID ? currentBlend.blendId : null),
  // 'no_id' | 'invalid' | 'valid', or null before the check finishes. Changes fire 'cc:blend-state'.
  state: () => currentBlend.state
};

// The forms that add the custom candle. Accessory quick-adds and forms with no buy button
// (Prestige's payment-installment form under the price) are left alone.
function customBlendForms() {
  const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
    .filter((form) => formSubmitButtons(form).length > 0);
  if (!customBlendVariantIds().size) return forms;
  return forms.filter((form) => window.ccCustomBlend.isVariant(form.querySelector('[name="id"]')?.value));
}

// A form's submit buttons, including ones outside it that point at it with form="…" (the sticky bar).
function formSubmitButtons(form) {
  const inside = Array.from(form.querySelectorAll('button[type="submit"], input[type="submit"]'));
  const outside = form.id
    ? Array.from(document.querySelectorAll(`button[type="submit"][form="${CSS.escape(form.id)}"], input[type="submit"][form="${CSS.escape(form.id)}"]`))
    : [];
  return inside.concat(outside);
}

// "Name your candle": sits above Add to cart on the custom blend's own form, prefilled with the
// blend's name. Its name="properties[Blend Name]" sends it with the add even if the cart-add hook
// fails; the hook also reads it by id (#blend-name). Hidden whenever there's no valid blend.
const BLEND_NAME_MAX = 30;

function mountBlendNameField(blendName) {
  const form = customBlendForms()[0];
  if (!form) return;

  let wrap = document.getElementById('blend-name-field');
  if (!wrap) {
    wrap = document.createElement('div');
    wrap.id = 'blend-name-field';
    wrap.className = 'blend-name-field';
    wrap.innerHTML = `
      <label for="blend-name" class="blend-name-field__label">Name your candle</label>
      <input type="text" id="blend-name" name="properties[Blend Name]" class="input"
             maxlength="${BLEND_NAME_MAX}" autocomplete="off" spellcheck="true"
             aria-describedby="blend-name-hint">
      <p id="blend-name-hint" class="blend-name-field__hint"></p>
    `;
    const buyButtons = form.querySelector('buy-buttons') || form.querySelector('.buy-buttons');
    if (buyButtons && buyButtons.parentNode) {
      buyButtons.parentNode.insertBefore(wrap, buyButtons);
    } else {
      form.prepend(wrap);
    }

    // An emptied field goes back to the blend's own name rather than ordering a nameless candle.
    const input = wrap.querySelector('input');
    input.addEventListener('blur', () => {
      const tidy = input.value.replace(/\s+/g, ' ').trim();
      input.value = tidy || input.dataset.blendName || '';
    });
  }

  const input = wrap.querySelector('input');
  // Keep a rename the customer already typed if the blend reloads (e.g. "Try again").
  if (!input.value.trim() || input.value === input.dataset.blendName) input.value = blendName;
  input.dataset.blendName = blendName;
  wrap.querySelector('#blend-name-hint').textContent =
    `We named it ${blendName}. Keep that or give it your own name, up to ${BLEND_NAME_MAX} characters.`;
  wrap.hidden = false;
}

function hideBlendNameField() {
  const wrap = document.getElementById('blend-name-field');
  if (wrap) wrap.hidden = true;
}

function mountBlendHeader() {
  const headerEl = document.getElementById('blend-result-header');
  if (!headerEl) return false;
  if (headerEl.dataset.mounted === 'true') return true;

  const formEl = document.querySelector('form[action*="/cart/add"]');
  const productInfoEl = document.querySelector('.product-info') || formEl?.closest('.product-info');

  try {
    // Prefer anchoring directly above the purchase form.
    if (formEl && formEl.parentNode) {
      formEl.parentNode.insertBefore(headerEl, formEl);
    } else if (productInfoEl) {
      productInfoEl.insertBefore(headerEl, productInfoEl.firstChild);
    } else {
      return false;
    }
  } catch (err) {
    window.ccDebug?.('mountBlendHeader failed', err?.message);
    return false;
  }

  headerEl.style.display = '';
  headerEl.dataset.mounted = 'true';
  return true;
}

function updateBlendHeader(state, options) {
  const headerEl = document.getElementById('blend-result-header');
  if (!headerEl) return;
  mountBlendHeader();

  const headingEl = headerEl.querySelector('[data-blend-header-heading]');
  const titleEl = headerEl.querySelector('[data-blend-header-title]');
  const bodyEl = headerEl.querySelector('[data-blend-header-body]');
  const actionsEl = headerEl.querySelector('[data-blend-header-actions]');
  const primaryEl = headerEl.querySelector('[data-blend-header-primary]');
  const secondaryEl = headerEl.querySelector('[data-blend-header-secondary]');

  const blendData = options?.blendData || null;
  const showActions = (show) => {
    if (actionsEl) actionsEl.style.display = show ? 'flex' : 'none';
    if (primaryEl) primaryEl.style.display = show ? 'inline-flex' : 'none';
  };

  headerEl.style.display = '';

  if (state === BLEND_STATE.VALID) {
    const blendName = getBlendHeaderName(blendData);
    const excerpt = makeExcerpt(getStoryTextForExcerpt(blendData), 170);
    if (headingEl) headingEl.textContent = 'Your personalized scent story';
    if (titleEl) {
      titleEl.textContent = blendName;
      titleEl.style.display = '';
    }
    if (bodyEl) bodyEl.textContent = excerpt || 'Your custom scent story will appear here.';
    showActions(false);
    if (secondaryEl) secondaryEl.style.display = 'none';
    return;
  }

  if (state === BLEND_STATE.NO_ID) {
    if (headingEl) headingEl.textContent = 'Create your custom candle';
    if (titleEl) titleEl.style.display = 'none';
    if (bodyEl) bodyEl.textContent = 'Take the scent quiz to reveal a one-of-a-kind blend crafted just for you.';
    showActions(true);
    if (primaryEl) {
      primaryEl.textContent = 'Start the quiz';
      primaryEl.setAttribute('href', '/pages/scent-quiz');
    }
    if (secondaryEl) secondaryEl.style.display = 'none';
    return;
  }

  if (state === BLEND_STATE.INVALID) {
    if (headingEl) headingEl.textContent = "We can't find that blend";
    if (titleEl) titleEl.style.display = 'none';
    if (bodyEl) bodyEl.textContent = 'This link may be expired or copied incorrectly.';
    showActions(true);
    if (primaryEl) {
      primaryEl.textContent = 'Start the quiz';
      primaryEl.setAttribute('href', '/pages/scent-quiz');
    }
    if (secondaryEl) {
      secondaryEl.textContent = 'Try again';
      secondaryEl.style.display = 'inline-flex';
    }
  }
}

function setPurchaseEnabled(enabled) {
  customBlendForms().forEach((form) => {
    if (!enabled) {
      form.classList.add('blend-purchase-disabled');
    } else {
      form.classList.remove('blend-purchase-disabled');
    }
    formSubmitButtons(form).forEach((btn) => {
      btn.disabled = !enabled;
      btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      if (!enabled) {
        btn.dataset.blendDisabled = 'true';
      } else {
        delete btn.dataset.blendDisabled;
      }
    });

    const paymentButton = form.querySelector('.shopify-payment-button');
    if (paymentButton) {
      if (!enabled) {
        paymentButton.dataset.prevDisplay = paymentButton.style.display || '';
        paymentButton.style.display = 'none';
      } else {
        paymentButton.style.display = paymentButton.dataset.prevDisplay || '';
        delete paymentButton.dataset.prevDisplay;
      }
    }
  });
}

function ensurePurchaseLockEl(form) {
  if (!form) return null;
  let lockEl = form.querySelector('.blend-purchase-lock');
  if (lockEl) return lockEl;

  lockEl = document.createElement('div');
  lockEl.className = 'blend-purchase-lock';
  lockEl.style.display = 'none';
  lockEl.innerHTML = `
    <div class="text-sm">
      <span data-blend-lock-text></span>
      <span class="blend-purchase-lock__actions">
        <a data-blend-lock-primary href="/pages/scent-quiz">Start the quiz</a>
        <span data-blend-lock-sep> · </span>
        <a data-blend-retry href="#">Try again</a>
      </span>
    </div>
  `;

  const buyButtons = form.querySelector('buy-buttons') || form.querySelector('.buy-buttons');
  if (buyButtons && buyButtons.parentNode) {
    buyButtons.parentNode.insertBefore(lockEl, buyButtons.nextSibling);
  } else {
    form.appendChild(lockEl);
  }

  return lockEl;
}

function updatePurchaseLock(state) {
  customBlendForms().forEach((form) => {
    const lockEl = ensurePurchaseLockEl(form);
    if (!lockEl) return;
    const headerEl = document.getElementById('blend-result-header');
    const headerMounted = headerEl && headerEl.dataset.mounted === 'true';
    if (headerMounted) {
      lockEl.style.display = 'none';
      return;
    }

    const textEl = lockEl.querySelector('[data-blend-lock-text]');
    const primaryEl = lockEl.querySelector('[data-blend-lock-primary]');
    const retryEl = lockEl.querySelector('[data-blend-retry]');
    const sepEl = lockEl.querySelector('[data-blend-lock-sep]');

    if (state === BLEND_STATE.VALID) {
      lockEl.style.display = 'none';
      return;
    }

    lockEl.style.display = 'block';
    if (state === BLEND_STATE.NO_ID) {
      if (textEl) textEl.textContent = 'Add to cart unlocks after your custom blend is created.';
      if (primaryEl) {
        primaryEl.textContent = 'Start the quiz';
        primaryEl.setAttribute('href', '/pages/scent-quiz');
      }
      if (retryEl) retryEl.style.display = 'none';
      if (sepEl) sepEl.style.display = 'none';
    }

    if (state === BLEND_STATE.INVALID) {
      if (textEl) textEl.textContent = 'This blend link is invalid. Create a new blend or retry loading it.';
      if (primaryEl) {
        primaryEl.textContent = 'Retake the quiz';
        primaryEl.setAttribute('href', '/pages/scent-quiz');
      }
      if (retryEl) retryEl.style.display = 'inline';
      if (sepEl) sepEl.style.display = 'inline';
    }
  });
}

function setBlendState(state, options = {}) {
  const messageEl = document.getElementById('blend-state-message');
  const titleEl = messageEl?.querySelector('[data-blend-state-title]');
  const bodyEl = messageEl?.querySelector('[data-blend-state-body]');
  const primaryEl = messageEl?.querySelector('[data-blend-state-primary]');
  const secondaryEl = messageEl?.querySelector('[data-blend-state-secondary]');
  const formulaEl = document.getElementById('custom-blend-formula');
  const storyEl = document.getElementById('blend-story');
  const resultEl = document.getElementById('blend-result');
  const nameWrapEl = document.getElementById('blend-name-wrap');
  const namePreviewEl = document.getElementById('blend-name-preview');
  const recEl = document.getElementById('curated-recommendation');
  const noteEl = document.getElementById('blend-fulfillment-note');

  window.ccDebug?.('blend state', state);
  currentBlend = { state, blendId: state === BLEND_STATE.VALID ? lastRequestedBlendId : null };
  document.dispatchEvent(new CustomEvent('cc:blend-state', { detail: { state } }));
  if (state !== BLEND_STATE.VALID) hideBlendNameField();
  setPurchaseEnabled(state === BLEND_STATE.VALID);
  updatePurchaseLock(state);
  updateBlendHeader(state, options);
  const headerMounted = Boolean(
    document.getElementById('blend-result-header')?.dataset?.mounted === 'true'
  );

  if (messageEl) messageEl.style.display = 'none';

  if (state === BLEND_STATE.VALID) {
    if (formulaEl) formulaEl.style.display = '';
    if (storyEl) storyEl.style.display = '';
    if (resultEl) resultEl.style.display = '';
    if (nameWrapEl) nameWrapEl.style.display = '';
    if (namePreviewEl && namePreviewEl.textContent?.trim()) namePreviewEl.style.display = 'block';
    return;
  }

  if (formulaEl) formulaEl.style.display = 'none';
  if (storyEl) {
    storyEl.textContent = '';
    storyEl.style.display = 'none';
  }
  if (resultEl) {
    resultEl.textContent = '';
    resultEl.style.display = 'none';
  }
  if (nameWrapEl) nameWrapEl.style.display = 'none';
  if (namePreviewEl) namePreviewEl.style.display = 'none';
  if (recEl) recEl.style.display = 'none';
  if (noteEl) noteEl.style.display = 'none';

  if (!messageEl) return;

  if (state === BLEND_STATE.NO_ID) {
    messageEl.style.display = headerMounted ? 'none' : 'block';
    if (titleEl) titleEl.textContent = 'Create your custom candle';
    if (bodyEl) bodyEl.textContent = 'Take the scent quiz to reveal a one-of-a-kind blend crafted just for you.';
    if (primaryEl) {
      primaryEl.textContent = 'Start the quiz';
      primaryEl.setAttribute('href', '/pages/scent-quiz');
    }
    if (secondaryEl) secondaryEl.style.display = 'none';
  }

  if (state === BLEND_STATE.INVALID) {
    messageEl.style.display = headerMounted ? 'none' : 'block';
    if (titleEl) titleEl.textContent = "We can't find that blend";
    if (bodyEl) bodyEl.textContent = 'Your link may have expired or the blend was removed. Take the quiz again to create a fresh one.';
    if (primaryEl) {
      primaryEl.textContent = 'Retake the quiz';
      primaryEl.setAttribute('href', '/pages/scent-quiz');
    }
    if (secondaryEl) {
      secondaryEl.textContent = 'Try again';
      secondaryEl.style.display = 'inline-flex';
    }
  }
}

window.showBlendError = function showBlendError(message = "We couldn’t load your blend.") {
  window.ccDebug?.('blend error', message);
  setBlendState(BLEND_STATE.INVALID, { message });
};

function injectBlendCardEmbedFromUrl() {
  const params = new URLSearchParams(window.location.search);
  let blendId = params.get('id') || '';
  if (!blendId) return;

  blendId = blendId.replace(/^blend-/, '');

  const target = document.querySelector('[data-blend-pdp-embed]');
  if (!target) return;

  const embedUrl = `${PORTAL_BASE}/embed/${blendId}`;
  window.ccDebug?.('PDP embed', embedUrl);

  target.innerHTML = `
    <iframe
      src="${embedUrl}"
      id="cc-blend-pdp-frame"
      scrolling="no"
      frameborder="0"
      style="width:100%;border:none;min-height:520px;transition:height 0.2s ease;"
      title="Your blend"
    ></iframe>
  `;

  window.addEventListener('message', function(e) {
    if (e.origin !== PORTAL_BASE) return;
    if (e.data?.type !== 'cc-card-height' && e.data?.type !== 'embed-height') return;
    const frame = document.getElementById('cc-blend-pdp-frame');
    if (frame) frame.style.height = e.data.height + 'px';
  });
}

let lastRequestedBlendId = null;
async function loadBlendById(blendId, options = {}) {
  const loaderEl = document.getElementById("blend-loading");
  const forceRefresh = Boolean(options.forceRefresh);

  lastRequestedBlendId = blendId || null;
  if (!blendId) {
    loaderEl?.style.setProperty('display', 'none');
    setBlendState(BLEND_STATE.NO_ID);
    return;
  }

  setPurchaseEnabled(false);
  const messageEl = document.getElementById('blend-state-message');
  if (messageEl) messageEl.style.display = 'none';
  const formulaEl = document.getElementById('custom-blend-formula');
  if (formulaEl) formulaEl.style.display = 'none';
  loaderEl?.style.setProperty('display', 'block');

  if (!forceRefresh) {
    const cached = quizStateManager?.getBlendCache?.(blendId);
    if (cached) {
      window.ccDebug?.('blend cache hit', blendId);
      // Line-item props read the last blend id's cache, so it must be this page's blend.
      quizStateManager?.setLastBlendId?.(blendId);
      setBlendState(BLEND_STATE.VALID);
      renderBlendResult(cached);
      injectBlendCardEmbedFromUrl();
      loaderEl?.style.setProperty('display', 'none');
      return;
    }
  }

  try {
    const data = await quizStateManager?.restoreBlendFromAzure?.(blendId);
    if (!data) throw new Error('Blend not found');

    quizStateManager?.setLastBlendId?.(blendId);
    reportInvalidBlend(data);
    setBlendState(BLEND_STATE.VALID);
    renderBlendResult(data);
    injectBlendCardEmbedFromUrl();
  } catch (err) {
    window.ccDebug?.('blend load failed', blendId, err?.message);
    if (quizStateManager?.getLastBlendId?.() === blendId) {
      quizStateManager?.clearLastBlendId?.();
    }
    try {
      sessionStorage.removeItem('blendSession.' + blendId);
    } catch {}
    setBlendState(BLEND_STATE.INVALID, { blendId });
  } finally {
    loaderEl?.style.setProperty('display', 'none');
  }
}

window.loadBlendFromAzureIfNeeded = async function loadBlendFromAzureIfNeeded() {
  if (!window.location.pathname.includes('/custom-blend')) return;
  const params = new URLSearchParams(window.location.search);
  const blendId = params.get('id');
  await loadBlendById(blendId);
};

document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/custom-blend')) return;
  mountBlendHeader();

  const retryEl = document.querySelector('[data-blend-state-secondary]');
  if (retryEl) {
    retryEl.addEventListener('click', function (event) {
      event.preventDefault();
      if (lastRequestedBlendId) {
        loadBlendById(lastRequestedBlendId, { forceRefresh: true });
      }
    });
  }

  document.querySelectorAll('[data-blend-retry]').forEach((retryLink) => {
    retryLink.addEventListener('click', function (event) {
      event.preventDefault();
      if (lastRequestedBlendId) {
        loadBlendById(lastRequestedBlendId, { forceRefresh: true });
      }
    });
  });

  const headerRetry = document.querySelector('[data-blend-header-secondary]');
  if (headerRetry) {
    headerRetry.addEventListener('click', function (event) {
      event.preventDefault();
      if (lastRequestedBlendId) {
        loadBlendById(lastRequestedBlendId, { forceRefresh: true });
      }
    });
  }
});

window.loadBlendFromAzureIfNeeded();

//8/10/25 - move order lineitem property injection logic to a blend-loader
// ──────────────────────────────────────────────────────────────
// Blend line item utilities: single source of truth
// Exposes: window.blendProps.buildLineItemProperties({ preferredName, fallbackName, quizVersion })
// ──────────────────────────────────────────────────────────────
(function initBlendProps() {
  if (window.blendProps) return;

  const safeParse = (v) => {
    if (!v) return null;
    if (typeof v === 'object') return v;
    try { return JSON.parse(v); } catch { return null; }
  };

  const normalizeCategory = (label) => {
    const map = {
      'spicy & warm': 'spicy', 'sweet & cozy': 'sweet', 'fresh & green': 'fresh',
      'citrus & bright': 'citrus', 'dark & mysterious': 'dark',
      'woody & earthy': 'woody', 'smoky & deep': 'smoky'
    };
    return map[label?.trim().toLowerCase()] || label?.trim() || '';
  };

  const mapCategoryToLabel = (key) => ({
    citrus: 'Citrus & Bright',
    sweet: 'Sweet & Cozy',
    spicy: 'Spicy & Warm',
    fresh: 'Fresh & Green',
    dark: 'Dark & Mysterious',
    woody: 'Woody & Earthy',
    smoky: 'Smoky & Deep'
  }[key?.trim().toLowerCase()] || key);

  const pickString = (...cands) =>
    cands.find(v => typeof v === 'string' && v.trim())?.trim() || '';

  const firstArray = (...cands) => cands.find(v => Array.isArray(v) && v.length) || null;

  function readState() {
    const quizDataRaw = window.quizStateManager?.get?.('customBlendFormula');
    const aiResultRaw  = window.quizStateManager?.get?.('blendAIResult');
    const quizAnswersRaw = window.quizStateManager?.get?.('quizAnswers') || sessionStorage.getItem('quizAnswers');

    const quizData = safeParse(quizDataRaw) || quizDataRaw || {};
    const aiResult = safeParse(aiResultRaw) || aiResultRaw || {};
    let quizAnswers = safeParse(quizAnswersRaw) ?? quizAnswersRaw;
    if (!Array.isArray(quizAnswers)) quizAnswers = [];

    let savedBlend = {};
    try {
      const id = localStorage.getItem('lastBlendId');
      const raw = id && sessionStorage.getItem('blendSession.' + id);
      if (raw) savedBlend = safeParse(raw) || {};
    } catch {}

    return { quizData, aiResult, quizAnswers, savedBlend };
  }

  function getBlendArray({ quizData, savedBlend, quizAnswers }) {
    // 1) quizData.fullFormula: "Sweet & Cozy, Spicy & Warm, ..."
    let blend = [];
    const parts = (typeof quizData?.fullFormula === 'string' ? quizData.fullFormula : '')
      .split(',').map(s => s.trim()).filter(Boolean);

    if (parts.length) {
      const pcts = Array.isArray(quizData?.percentages) ? quizData.percentages : [];
      const denom = parts.length || 1;
      blend = parts.map((cat, i) => {
        const pct = Number.isFinite(Number(pcts[i])) ? Number(pcts[i]) : Math.round(100 / denom);
        return { category: cat, percent: pct };
      });
    }

    // 2) Saved session: fullBreakdown ("Label:60,Label:40") or topFormula ("A + B")
    if (!blend.length) {
      if (typeof savedBlend?.fullBreakdown === 'string') {
        blend = savedBlend.fullBreakdown.split(',').map(pair => {
          const [label, pct] = pair.split(':');
          return { category: label?.trim(), percent: parseInt(pct, 10) || 0 };
        }).filter(b => b.category);
      } else if (typeof savedBlend?.topFormula === 'string') {
        const pf = savedBlend.topFormula.split(' + ').map(s => s.trim()).filter(Boolean);
        const denom = pf.length || 1;
        blend = pf.map(c => ({ category: c, percent: Math.round(100 / denom) }));
      }
    }

    // 3) Infer from quiz answers (normalize to 100)
    if (!blend.length && Array.isArray(quizAnswers) && quizAnswers.length) {
      const counts = {};
      quizAnswers.forEach(e => {
        const key = normalizeCategory(e?.category || '');
        if (key) counts[key] = (counts[key] || 0) + 1;
      });
      const keys = Object.keys(counts).sort((a,b) => counts[b]-counts[a]);
      const total = keys.reduce((s,k) => s + counts[k], 0) || 1;
      let running = 0;
      keys.forEach((k, idx) => {
        let pct = Math.round((counts[k] / total) * 100);
        if (idx === keys.length - 1) pct = 100 - running;
        running += pct;
        blend.push({ category: k, percent: pct });
      });
    }

    return blend;
  }

  function getStory({ aiResult, savedBlend, blend, quizAnswers }) {
  // 1) **Primary**: the key your renderer uses
  // (this matches the Azure function + renderBlendResult)
  let text =
    (typeof aiResult?.story === 'string' && aiResult.story.trim()) ||
    (typeof savedBlend?.story === 'string' && savedBlend.story.trim());

  // 2) Common alternates seen in earlier iterations (just in case)
  if (!text) {
    text =
      (typeof savedBlend?.blendStory === 'string' && savedBlend.blendStory.trim()) ||
      (typeof savedBlend?.result?.story === 'string' && savedBlend.result.story.trim());
  }

  // 3) **Bulletproof fallback**: use what’s already rendered in the DOM
  if (!text) {
    const domStory = document.getElementById('blend-story')?.textContent?.trim();
    if (domStory) text = domStory;
  }

  // 4) Last-ditch: generate a tasteful single line from the top two notes
  if (!text && Array.isArray(blend) && blend.length) {
    const top = blend.slice(0,2).map(b => b.category).filter(Boolean);
    if (top.length) text = `A custom blend shaped by ${top.join(' and ')}, crafted to match your quiz choices.`;
  }

  return text || '';
}


  function getRecipeText({ aiResult, savedBlend }) {
    let arr = firstArray(
      aiResult?.fullFormula, aiResult?.recipe, aiResult?.formula, aiResult?.oils,
      savedBlend?.fullFormula, savedBlend?.recipe
    );

    if (arr) {
      const items = arr.map(r => {
        if (typeof r === 'string') return r; // already formatted
        const oil = r?.oil || r?.name || r?.component || r?.scent || r?.label || r?.note || '';
        const grams = r?.grams ?? r?.g ?? r?.weight_g ?? r?.weightG ?? r?.weight;
        const pct = r?.percent ?? r?.pct;
        if (!oil) return null;
        if (grams != null && !Number.isNaN(Number(grams))) return `${oil}: ${Math.round(Number(grams))}g`;
        if (pct != null && !Number.isNaN(Number(pct))) return `${oil}: ${Number(pct)}%`;
        return oil;
      }).filter(Boolean);
      if (items.length) return items.join(', ');
    }

    return pickString(
      aiResult?.recipeText, aiResult?.fullFormulaText,
      savedBlend?.recipeText, savedBlend?.fullFormulaText
    );
  }

  function buildLineItemProperties({ preferredName, fallbackName, quizVersion = 'v1' } = {}) {
    const { quizData, aiResult, quizAnswers, savedBlend } = readState();

    const blend = getBlendArray({ quizData, savedBlend, quizAnswers });
    const storyText = getStory({ aiResult, savedBlend, blend, quizAnswers });
    const recipeText = getRecipeText({ aiResult, savedBlend });

    const tidy = (v) => String(v || '').replace(/\s+/g, ' ').trim();
    const aiName = tidy(fallbackName) || tidy(savedBlend?.blendName) || tidy(aiResult?.suggested_blend_name);
    const blendName = tidy(preferredName).slice(0, BLEND_NAME_MAX) || aiName || 'Untitled Blend';

    const blendId = window.ccCustomBlend?.validBlendId?.()
      || savedBlend?.blendId
      || new URLSearchParams(window.location.search).get('id')
      || localStorage.getItem('lastBlendId')
      || null;

    const props = {
      'Blend Name': blendName,
      // The blend records which quiz made it; the caller's value is only a fallback for v1 sessions.
      '_Quiz Version': savedBlend?.quizVersion || quizVersion
    };

    if (blendId) props['_BlendId'] = blendId;
    // A renamed candle keeps the engine's name alongside, for fulfilment and the portal.
    if (aiName && blendName !== aiName) props['_AI Name'] = aiName;

    if (blend.length) {
      const topTwo = blend.slice(0, 2).map(b => mapCategoryToLabel(normalizeCategory(b.category)));
      props['Top Formula'] = topTwo.join(' + ');
      props['_Full Breakdown'] = blend
        .map(b => `${mapCategoryToLabel(normalizeCategory(b.category))}:${b.percent}`)
        .join(',');
    }

    if (storyText)  props['_Story']  = storyText;
    if (recipeText) props['_Recipe'] = recipeText;

    // Answer echoes (optional but useful)
    if (Array.isArray(quizAnswers) && quizAnswers.length) {
      quizAnswers.forEach((entry, i) => {
        const label = `_${'Q' + (i + 1)}`;
        // v1 answers carry the family they scored for; v2 answers don't (the engine scores them).
        props[label] = entry.category ? `${entry.category} | ${entry.answer}` : entry.answer;
      });
    }

    // For debugging: persist what we sent (non-blocking)
    try { sessionStorage.setItem('lastLineItemProps', JSON.stringify(props)); } catch {}

    return props;
  }

  window.blendProps = { buildLineItemProperties };
})();
